// Team member images
const TEAM_IMAGES = {
  // Portfolio Management Group
  guillaumeBenhamou: '/F.Guillaume.jpg',
  laureDHauteville: '/F.placeholder.jpg',
  bernardLandes: '/F.Bernard.jpg',
  sylvieSilvain: '/F.Sylvie.jpg',
  candiceMangin: '/F.Candice.jpg',
  anneBassac: '/F.Anne.jpg',

  // Value Creation Group
  gregoryFreva: '/F.Gregory.jpg',
  charlesBouygues: '/F.Charles.jpg',
  quentinParadowski: '/F.Quentin.jpg',
  lotfiAinseur: '/F.Lofti.jpg',
  romualdDaussy: '/F.Romuald.jpg',

  // Senior Advisory Group
  philippeCarli: '/F.Christophe.jpg',
  kathleenWantz: '/F.Kathleen.jpg',
  marwanLahoud: '/F.Marwan.jpg',
  yannickBezard: '/F.Yannick.jpg',

  francoisPaque: '/F.Francois.jpg',
  isabelleDriver: '/F.Isabelle.jpg',
  matthieuJan2: '/F.Jan.jpg',
  jeromeDuprez: '/F.Jerome.jpg',
  laurentColletBillon: '/Laurent.png',
  loicBournon: '/F.Loic.jpg',
  maloryMertz: '/F.Malory.jpg',
  christopheCarli: '/F.Phillipe.jpg',
  maylineBenaets: '/F.Mayline.jpg',

  // Missing/placeholder
  missingDetails: '/8.png',
  priyaDerivery: '/F.Priya.jpg',

  // Ocean Peak Management
  matthieuJan: '/F.Jan.jpg'
};

// Portfolio Management Group
export const portfolioManagement = [
  {
    name: 'Guillaume Benhamou',
    title: 'Partner & Chief Executive Officer, Ocean Peak Group',
    title2: 'Chief Executive Officer, Moret Industries Group',
    titles: [
      'Partner & Chief Executive Officer, Ocean Peak Group',
      'Chief Executive Officer, Moret Industries Group'
    ],
    titleFr: 'Associé et Directeur général, Ocean Peak Group',
    title2Fr: 'Directeur général, Moret Industries Group',
    titlesFr: [
      'Associé et Directeur général, Ocean Peak Group',
      'Directeur général, Moret Industries Group'
    ],
    bio: 'Guillaume is a Partner at Ocean Peak and the CEO of Moret Industries. Guillaume co-founded Ocean Peak in 2023 with Gr\u00e9gory and Charles. Previously Guillaume was the CEO of Tikehau Ace Capital from 2019 to 2022, a Private Equity firm focused on Aerospace & Defence and Cybersecurity. During that period, Ace grew from \u20ac300m to c\u20ac1.4Bn, with a portfolio of 40 companies employing 20,000 people and generating c\u20ac2Bn in aggregate revenue. Before that Guillaume developed the Private Equity arm of Tikehau Capital, after prior experiences at BCG, Audax Group and Mubadala.',
    bioFr: 'Guillaume est associé chez Ocean Peak et directeur général de Moret Industries. Il a cofondé Ocean Peak en 2023 avec Grégory et Charles. Auparavant, Guillaume était directeur général de Tikehau Ace Capital de 2019 à 2022, une société de capital-investissement spécialisée dans l\'aérospatiale, la défense et la cybersécurité. Durant cette période, Ace est passé de 300 M€ à environ 1,4 Md€, avec un portefeuille de 40 entreprises employant 20 000 personnes et générant environ 2 Md€ de chiffre d\'affaires. Avant cela, Guillaume a développé la branche capital-investissement de Tikehau Capital, après des expériences préalables chez BCG, Audax Group et Mubadala.',
    education: 'Guillaume is a graduate of HEC Paris with an MSc in Strategic Management',
    educationFr: 'Diplômé de HEC Paris avec un Master en management stratégique.',
    language: ['English', 'French', 'German'],
    languageFr: ['Anglais', 'Français', 'Allemand'],
    sectorFocus: ['Aerospace', 'Defence', 'Energy'],
    sectorFocusFr: ['Aérospatiale', 'Défense', 'Énergie'],
    countryFocus: ['France', 'Germany', 'Benelux', 'United Kingdom'],
    countryFocusFr: ['France', 'Allemagne', 'Benelux', 'Royaume-Uni'],
    functionalExpertise: ['Strategy', 'Finance', 'Management'],
    functionalExpertiseFr: ['Stratégie', 'Finance', 'Management'],
    image: TEAM_IMAGES.guillaumeBenhamou,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/guillaumebenhamou/',
    team: 'portfolio-management',
    position: 'partner',
    office: 'paris'
  },
  {
    name: "Laure d'Hauteville",
    title: 'Chief Financial Officer',
    title2: 'Moret Industries Group',
    titles: [
      'Chief Financial Officer, Moret Industries Group'
    ],
    titleFr: 'Directrice financière',
    title2Fr: 'Moret Industries Group',
    titlesFr: [
      'Directrice financière, Moret Industries Group'
    ],
    bio: "Laure is Chief Financial Officer at Moret Industries Group. Laure brings extensive experience in Corporate Finance. Most recently, Laure was Group Chief Financial Officer and a member of the Executive Committee of PulluP Entertainment, a listed video game publisher and developer, where she contributed to the evolution of the company's business model. Previously, Laure spent 10 years at Orano, a global leader in the nuclear industry, where she served as a Financial Controller both in the United States and at Group level, after which she joined Gameloft, an international mobile game developer, where she spent 7 years as Deputy CFO and member of the Executive Committee.",
    bioFr: 'Laure est directrice financière du groupe Moret Industries Group. Laure possède une vaste expérience en finance d\'entreprise. Plus récemment, Laure était directrice financière groupe et membre du comité exécutif de PulluP Entertainment, un éditeur et développeur de jeux vidéo coté en bourse, où elle a contribué à l\'évolution du modèle économique de l\'entreprise. Auparavant, Laure a passé 10 ans chez Orano, un leader mondial de l\'industrie nucléaire, où elle a exercé les fonctions de contrôleuse financière aux États-Unis puis au niveau du groupe, après quoi elle a rejoint Gameloft, un développeur international de jeux sur mobile, où elle a passé 7 ans en tant que directrice financière adjointe et membre du comité exécutif.',
    education: 'Laure is a graduate of EM Lyon with a MSc in Finance',
    educationFr: 'Laure est diplômée de l\'EM Lyon avec un Master en finance.',
    language: ['English', 'French'],
    languageFr: ['Anglais', 'Français'],
    sectorFocus: ['Energy & Utilities'],
    sectorFocusFr: ['Énergie et services publics'],
    functionalExpertise: ['Finance', 'Investor Relations', 'Technology'],
    functionalExpertiseFr: ['Finance', 'Relations Investisseurs', 'Technologie'],
    countryFocus: ['France', 'United Kingdom'],
    countryFocusFr: ['France', 'Royaume-Uni'],
    image: TEAM_IMAGES.laureDHauteville,
    imageScale: 1.15,
    imagePosition: 'center 0%',
    linkedin: 'https://www.linkedin.com/in/laure-d-hauteville',
    team: 'portfolio-management',
    position: 'officer',
    office: 'paris'
  },
  {
    name: 'Anne Bassac',
    title: 'Principal, Ocean Peak Group',
    titles: [
      'Principal, Ocean Peak Group'
    ],
    titleFr: 'Collaboratrice, Ocean Peak Group',
    titlesFr: [
      'Collaboratrice, Ocean Peak Group'
    ],
    bio: 'Anne is an Associate at Ocean Peak, in the Portfolio Management group. Previously Anne worked for over three years in M&A at Vulcain, which has become Clearwater CF since. Since joining, Ocean Peak, Anne has been directly involved in supporting Moret Industries, and led the execution of OPK\u2019s investment in OPEO Consulting.',
    bioFr: 'Anne est collaboratrice chez Ocean Peak, au sein du groupe Gestion de Portefeuille. Auparavant, elle a travaillé pendant plus de trois ans en fusions-acquisitions chez Vulcain, devenu Clearwater CF. Depuis qu\'elle a rejoint Ocean Peak, Anne est directement impliquée dans l\'accompagnement de Moret Industries et a piloté l\'exécution de l\'investissement d\'OPK dans OPEO Consulting.',
    education: 'Anne is a graduate of Institut Catholique de Paris (ICP) with a Bachelor\'s degree in Law and Philosophy, and of EM Lyon Business School with an MSc in Management',
    educationFr: 'Diplômée de l\'Institut Catholique de Paris (ICP) avec une licence en droit et philosophie, et de l\'EM Lyon Business School avec un Master en management.',
    language: ['French', 'English'],
    languageFr: ['Français', 'Anglais'],
    sectorFocus: ['Food & Agriculture', 'Healthcare'],
    sectorFocusFr: ['Agroalimentaire', 'Santé'],
    countryFocus: ['France', 'Benelux', 'Spain'],
    countryFocusFr: ['France', 'Benelux', 'Espagne'],
    functionalExpertise: ['Finance', 'Mergers & Acquisitions'],
    functionalExpertiseFr: ['Finance', 'Fusions & Acquisitions'],
    image: TEAM_IMAGES.anneBassac,
    imageScale: 1.25,
    imagePosition: 'center 40%',
    linkedin: 'https://www.linkedin.com/in/anne-bassac-994301129',
    team: 'portfolio-management',
    position: 'associate',
    office: 'paris'
  },
  {
    name: 'Matthieu Jan',
    title: 'Recruiting Officer',
    title2: 'Ocean Peak Group',
    titles: [
      'Recruiting Officer, Ocean Peak Group'
    ],
    titleFr: 'Responsable du recrutement',
    title2Fr: 'Ocean Peak Group',
    titlesFr: [
      'Responsable du recrutement, Ocean Peak Group'
    ],
    bio: 'Matthieu Jan is a Principal at Ocean Peak, in charge of Interim and Full Time Recruiting in the Value Creation group. Previously at Grant Alexander and Delville Management, he built and expanded the Transition Management division of each firm, growing revenue to around \u20ac20M in each and participating in over 200 engagements for industrial and service sector clients over 10 years. Matthieu has built his approach around operational excellence and people-focus to turn challenging situations into opportunities to find top level talent for organizations. Outside of work, Matthieu is actively involved in education initiatives and youth rugby coaching, reflecting his commitment to leadership as a force for positive impact.',
    bioFr: 'Matthieu est directeur principal chez Ocean Peak, en charge du recrutement intérimaire et permanent au sein du groupe Création de Valeur. Auparavant chez Grant Alexander et Delville Management, il a créé et développé la division Management de Transition de chaque cabinet, portant le chiffre d\'affaires à environ 20 M€ chacun et participant à plus de 200 missions pour des clients industriels et de services sur 10 ans. Matthieu a construit son approche autour de l\'excellence opérationnelle et de l\'orientation humaine pour transformer les situations difficiles en opportunités de trouver les meilleurs talents pour les organisations. En dehors du travail, Matthieu est activement impliqué dans des initiatives éducatives et l\'entraînement de rugby pour les jeunes.',
    education: 'Matthieu holds a Master\u2019s in International Tourism Marketing from \u00c9cole Sup\u00e9rieure de Tourisme (EST) Paris and a Bachelor\u2019s in Law from Universit\u00e9 Panth\u00e9on-Assas (Paris II)',
    educationFr: 'Master en marketing touristique international de l\'École Supérieure de Tourisme (EST) Paris et licence en droit de l\'Université Panthéon-Assas (Paris II).',
    language: ['French', 'English'],
    languageFr: ['Français', 'Anglais'],
    sectorFocus: ['Aerospace & Defence', 'Healthcare', 'Energy & Utilities'],
    sectorFocusFr: ['Aérospatiale et défense', 'Santé', 'Énergie et services publics'],
    countryFocus: ['France', 'Spain', 'Italy', 'Benelux'],
    countryFocusFr: ['France', 'Espagne', 'Italie', 'Benelux'],
    functionalExpertise: ['Interim Management', 'Leadership Recruitment'],
    functionalExpertiseFr: ['Management de Transition', 'Recrutement de Dirigeants'],
    image: TEAM_IMAGES.matthieuJan,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/matthieujan',
    team: 'value-creation',
    position: 'principal',
    office: 'paris'
  }
];

// Value Creation Group
export const valueCreationGroup = [
  {
    name: 'Gr\u00e9gory Freva',
    title: 'Partner & Chief Operating Officer, Ocean Peak Group',
    title2: 'Chief Operating Officer, Moret Industries Group',
    titles: [
      'Partner & Chief Operating Officer, Ocean Peak Group',
      'Chief Operating Officer, Moret Industries Group'
    ],
    titleFr: 'Associé et Directeur des opérations, Ocean Peak Group',
    title2Fr: 'Directeur des opérations, Moret Industries Group',
    titlesFr: [
      'Associé et Directeur des opérations, Ocean Peak Group',
      'Directeur des opérations, Moret Industries Group'
    ],
    bio: 'Gr\u00e9gory is a Partner at Ocean Peak and the COO of Moret Industries. Gr\u00e9gory co-founded Ocean Peak in 2023 with Charles and Guillaume. Previously, Gr\u00e9gory acted as COO of various industrial companies during periods of transformation, with a focus on Aerospace & Defence. Gr\u00e9gory was the Industrial Director of LISI Aerospace from 2018 to 2022. Before that, Gr\u00e9gory led a 600 FTE site for Collins Aerospace between 2016 and 2018, where he previously was Lean site transformation leader and head of the electric drives program. Gr\u00e9gory started his career working on drone programs at Safran between 2002 and 2008.',
    bioFr: 'Grégory est associé chez Ocean Peak et directeur des opérations de Moret Industries. Il a cofondé Ocean Peak en 2023 avec Charles et Guillaume. Auparavant, Grégory a exercé les fonctions de directeur des opérations dans diverses entreprises industrielles en période de transformation, avec un focus sur l\'aérospatiale et la défense. Il a été directeur industriel de LISI Aerospace de 2018 à 2022. Avant cela, il a dirigé un site de 600 ETP pour Collins Aerospace entre 2016 et 2018, où il était auparavant responsable de la transformation Lean et chef du programme de propulsion électrique. Grégory a débuté sa carrière en travaillant sur des programmes de drones chez Safran entre 2002 et 2008.',
    education: 'Gr\u00e9gory is a graduate of the Ecole Nationale Sup\u00e9rieure de l\'Electronique et de ses Applications with a Master\'s degree in Engineering, Electronics and Project management',
    educationFr: 'Diplômé de l\'École Nationale Supérieure de l\'Électronique et de ses Applications avec un Master en ingénierie, électronique et gestion de projet.',
    language: ['French', 'English'],
    languageFr: ['Français', 'Anglais'],
    sectorFocus: ['Aerospace & Defence', 'Food & Agriculture'],
    sectorFocusFr: ['Aérospatiale et défense', 'Agroalimentaire'],
    countryFocus: ['France', 'Benelux'],
    countryFocusFr: ['France', 'Benelux'],
    functionalExpertise: ['Operations', 'Engineering', 'Program Management'],
    functionalExpertiseFr: ['Opérations', 'Ingénierie', 'Gestion de Programmes'],
    image: TEAM_IMAGES.gregoryFreva,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/gregory-freva',
    team: 'value-creation',
    position: 'partner',
    office: 'paris'
  },
  {
    name: 'Charles Bouygues',
    title: 'Partner & Chief Transformation Officer, Ocean Peak Group',
    title2: 'Chief Transformation Officer, Ocean Peak Group',
    titles: [
      'Partner & Chief Transformation Officer, Ocean Peak Group',
      'Chief Transformation Officer, Ocean Peak Group'
    ],
    titleFr: 'Associé et Directeur de la transformation, Ocean Peak Group',
    title2Fr: 'Directeur de la transformation, Ocean Peak Group',
    titlesFr: [
      'Associé et Directeur de la transformation, Ocean Peak Group',
      'Directeur de la transformation, Ocean Peak Group'
    ],
    bio: 'Charles is a Partner at Ocean Peak and the CTO of Moret Industries. Charles co-founded Ocean Peak in 2023 with Gr\u00e9gory and Guillaume. Previously, Charles was the Head of Transformation & Integration at Nexteam from 2019 to 2023, a leading Aerospace & Defence primary metal parts manufacturer. During that period, Charles worked on a variety of transformation issues across industrial, operational, and digital issues. Before that Charles was the CEO of Mecafi, a \u20ac100m revenue acquisition by Nexteam completed in 2018. From 2012 to 2018, Charles took on various C-level roles at industrial midmarket companies undergoing transformation, with a track record of major recoveries and value creation over a decade of engagements. Charles was previously a Consultant at McKinsey in its Operations Practice between 2007 and 2012.',
    bioFr: 'Charles est associé chez Ocean Peak et directeur de la transformation de Moret Industries. Il a cofondé Ocean Peak en 2023 avec Grégory et Guillaume. Auparavant, Charles était responsable de la transformation et de l\'intégration chez Nexteam de 2019 à 2023, un fabricant de premier plan de pièces métalliques primaires pour l\'aérospatiale et la défense. Il a travaillé sur des problématiques de transformation industrielle, opérationnelle et numérique. Avant cela, Charles était directeur général de Mecafi, une acquisition de 100 M€ de chiffre d\'affaires réalisée par Nexteam en 2018. De 2012 à 2018, il a occupé divers postes de direction dans des entreprises industrielles de taille intermédiaire en transformation. Charles a été consultant chez McKinsey dans la pratique opérations entre 2007 et 2012.',
    education: 'Charles is a graduate of Ecole Nationale Sup\u00e9rieure des Arts et M\u00e9tiers with a Master\'s degree in Mechanical Engineering',
    educationFr: 'Diplômé de l\'École Nationale Supérieure des Arts et Métiers avec un Master en ingénierie mécanique.',
    language: ['English', 'French'],
    languageFr: ['Anglais', 'Français'],
    sectorFocus: ['Aerospace & Defence', 'Healthcare'],
    sectorFocusFr: ['Aérospatiale et défense', 'Santé'],
    countryFocus: ['France', 'Spain', 'United Kingdom'],
    countryFocusFr: ['France', 'Espagne', 'Royaume-Uni'],
    functionalExpertise: ['Operations & Manufacturing', 'Digital', 'Management'],
    functionalExpertiseFr: ['Opérations & Production', 'Digital', 'Management'],
    image: TEAM_IMAGES.charlesBouygues,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/charles-bouygues',
    team: 'value-creation',
    position: 'partner',
    office: 'paris'
  },
  {
    name: 'Quentin Paradowski',
    title: 'Chief Human Resources Officer',
    title2: 'Moret Industries Group',
    titles: [
      'Chief Human Resources Officer, Moret Industries Group'
    ],
    titleFr: 'Directeur des ressources humaines',
    title2Fr: 'Moret Industries Group',
    titlesFr: [
      'Directeur des ressources humaines, Moret Industries Group'
    ],
    bio: 'Quentin is Chief HR Officer at Moret Industries, where he leads the group\u2019s global people strategy and enables its growth ambitions. Before joining Moret, he served as CHRO of Axereal, an international agrifood group of 3,200 employees generating \u20ac4bn in revenue, where he led the HR function at group level and drove strategic transformation across multiple countries. Earlier, he held consulting and HR roles at Michael Page and Airbus Group.',
    bioFr: 'Quentin est directeur des ressources humaines chez Moret Industries, où il dirige la stratégie globale en matière de ressources humaines et accompagne les ambitions de croissance du groupe. Avant de rejoindre Moret, il était DRH d\'Axereal, un groupe agro-alimentaire international de 3 200 employés générant 4 Md€ de chiffre d\'affaires, où il dirigeait la fonction RH au niveau du groupe et pilotait la transformation stratégique dans plusieurs pays. Auparavant, il a occupé des fonctions de conseil et de RH chez Michael Page et Airbus Group.',
    education: 'Quentin is a graduate of Toulouse School of Management with a MSc in International HR Management',
    educationFr: 'Diplômé de Toulouse School of Management avec un Master en gestion internationale des ressources humaines.',
    language: ['English', 'French'],
    languageFr: ['Anglais', 'Français'],
    sectorFocus: ['Food & Agriculture', 'Aerospace & Defence'],
    sectorFocusFr: ['Agroalimentaire', 'Aérospatiale et défense'],
    countryFocus: ['France', 'Switzerland', 'Benelux'],
    countryFocusFr: ['France', 'Suisse', 'Benelux'],
    functionalExpertise: ['People/Human Resources', 'Transformation', 'Governance'],
    functionalExpertiseFr: ['Ressources Humaines', 'Transformation', 'Gouvernance'],
    image: TEAM_IMAGES.quentinParadowski,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/quentin-paradowski',
    team: 'value-creation',
    position: 'officer',
    office: 'paris'
  },
  {
    name: 'Romuald Daussy',
    title: 'Chief Information Officer',
    title2: 'Moret Industries Group',
    titles: [
      'Chief Information Officer, Moret Industries Group'
    ],
    titleFr: 'Responsable des technologies de l\'information',
    title2Fr: 'Moret Industries Group',
    titlesFr: [
      'Responsable des technologies de l\'information, Moret Industries Group'
    ],
    bio: 'Romuald leads the Information Technology team at Moret Industries, managing networks, applications, and cybersecurity for the subsidiaries of the Group. Romuald started his career 18 years ago as an IT technician at Maguin, a subsidiary of Moret Industries. After a few years, Romuald moved into the Group IT team, and has led the team since 2023.',
    bioFr: 'Romuald dirige l\'équipe des technologies de l\'information chez Moret Industries, gérant les réseaux, les applications et la cybersécurité pour les filiales du groupe. Il a débuté sa carrière il y a 18 ans en tant que technicien informatique chez Maguin, une filiale de Moret Industries. Après quelques années, Romuald a intégré l\'équipe informatique du groupe, qu\'il dirige depuis 2023.',
    education: 'Romuald holds a Bachelor\'s in IT Management, Networks and Systems Administration',
    educationFr: 'Licence en gestion informatique, réseaux et administration des systèmes.',
    language: ['French', 'English'],
    languageFr: ['Français', 'Anglais'],
    sectorFocus: ['Aerospace & Defence'],
    sectorFocusFr: ['Aérospatiale et défense'],
    countryFocus: ['France', 'Benelux', 'Switzerland'],
    countryFocusFr: ['France', 'Benelux', 'Suisse'],
    functionalExpertise: ['Technology'],
    functionalExpertiseFr: ['Technologie'],
    image: TEAM_IMAGES.romualdDaussy,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/romuald-daussy',
    team: 'value-creation',
    position: 'officer',
    office: 'paris'
  },
  {
    name: 'Sylvie Silvain',
    title: 'Accounting Officer',
    title2: 'Moret Industries Group',
    titles: [
      'Accounting Officer, Moret Industries Group'
    ],
    titleFr: 'Responsable comptable',
    title2Fr: 'Moret Industries Group',
    titlesFr: [
      'Responsable comptable, Moret Industries Group'
    ],
    bio: 'Sylvie joined Moret Industries in 2008, initially as site director for Fonderies de Marly, a group subsidiary. Sylvie joined the group finance team 10 years ago, managing all aspects of accounting and cash management, including group-level consolidation accounting.',
    bioFr: 'Sylvie a rejoint Moret Industries en 2008, d\'abord en tant que directrice de site pour Fonderies de Marly, une filiale du groupe. Elle a intégré l\'équipe financière du groupe il y a 10 ans, gérant tous les aspects de la comptabilité et de la gestion de trésorerie, y compris la consolidation comptable au niveau du groupe.',
    education: 'Sylvie holds a Bachelor\'s in Finance from Universite Polytechnique Hauts-de-France',
    educationFr: 'Licence en finance de l\'Université Polytechnique Hauts-de-France.',
    language: ['French'],
    languageFr: ['Français'],
    sectorFocus: ['Aerospace & Defence', 'Energy & Utilities'],
    sectorFocusFr: ['Aérospatiale et défense', 'Énergie et services publics'],
    countryFocus: ['France', 'Benelux', 'Germany'],
    countryFocusFr: ['France', 'Benelux', 'Allemagne'],
    functionalExpertise: ['Finance'],
    functionalExpertiseFr: ['Finance'],
    image: TEAM_IMAGES.sylvieSilvain,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/sylvie-silvain-2b0a37103',
    team: 'portfolio-management',
    position: 'principal',
    office: 'paris'
  },
  {
    name: 'Priya Derivery',
    title: 'Chief Accountant',
    title2: 'Moret Industries Group',
    titles: [
      'Chief Accountant, Moret Industries Group'
    ],
    titleFr: 'Responsable comptable',
    title2Fr: 'Moret Industries Group',
    titlesFr: [
      'Directrice Comptable, Moret Industries Group'
    ],
    bio: 'Priya joined Moret Industries in 2026, from PullUp Entertainment. Priya began her career in chartered accountancy firms such as Mazars doing legal audits/revisions for 7 years. She then became Southern Europe Controller for Axis Communications, a leader in videosurveillance cameras where she spent 6 years reorganising the team and integrating new acquisitions. She then joined Unify (digital unit of TF1) where she implemented a new ERP (Workday), after which she joined PullUp Entertainment (Video game publisher) as Chief Accountant.',
    bioFr: 'Priya a rejoint Moret Industries en 2026, en provenance de PullUp Entertainment. Priya a d\u00e9but\u00e9 sa carri\u00e8re dans des cabinets d\'expertise comptable tels que Mazars, r\u00e9alisant des audits l\u00e9gaux et des r\u00e9visions pendant 7 ans. Elle est ensuite devenue Contr\u00f4leuse Europe du Sud chez Axis Communications, un leader dans les cam\u00e9ras de vid\u00e9osurveillance, o\u00f9 elle a pass\u00e9 6 ans \u00e0 r\u00e9organiser l\'\u00e9quipe et int\u00e9grer de nouvelles acquisitions. Elle a ensuite rejoint Unify (unit\u00e9 num\u00e9rique de TF1) o\u00f9 elle a mis en place un nouvel ERP (Workday), apr\u00e8s quoi elle a rejoint PullUp Entertainment (\u00e9diteur de jeux vid\u00e9o) en tant que Directrice comptable.',
    education: 'Priya holds a DESCF (MSc in Accounting and Finance)',
    educationFr: 'Priya est titulaire d\'un DESCF (Master en comptabilit\u00e9 et finance).',
    language: ['English', 'French', 'Tamil'],
    languageFr: ['Anglais', 'Fran\u00e7ais', 'Tamoul'],
    sectorFocus: ['Food & Agriculture', 'Aerospace & Defence'],
    sectorFocusFr: ['Agroalimentaire', 'A\u00e9rospatiale et d\u00e9fense'],
    countryFocus: ['Pan-European'],
    countryFocusFr: ['Pan-europ\u00e9en'],
    functionalExpertise: ['Accountancy', 'IT Systems'],
    functionalExpertiseFr: ['Comptabilit\u00e9', 'Syst\u00e8mes informatiques'],
    image: TEAM_IMAGES.priyaDerivery,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: null,
    team: 'value-creation',
    position: 'officer',
    office: 'paris'
  },
  {
    name: 'Candice Mangin',
    title: 'General Affairs Associate',
    title2: 'Moret Industries Group',
    titles: [
      'General Affairs Associate, Moret Industries Group'
    ],
    titleFr: 'Collaboratrice des affaires générales',
    title2Fr: 'Moret Industries Group',
    titlesFr: [
      'Collaboratrice des affaires générales, Moret Industries Group'
    ],
    bio: 'Candice Mangin is an experienced Office Manager specializing in cross-functional coordination, project management, in support of executive leadership. With a background in industrial and international environments, she supports the group across insurance, fleet management, and office management roles.',
    bioFr: 'Candice Mangin est une responsable administrative expérimentée spécialisée dans la coordination transversale, la gestion de projets, en soutien à la direction générale. Avec une expérience dans des environnements industriels et internationaux, elle accompagne le groupe dans les domaines de l\'assurance, la gestion de flotte et la gestion des bureaux.',
    education: 'Candice holds a Certification and Master\'s Degree in Project Management',
    educationFr: 'Certification et Master en gestion de projet.',
    language: ['French', 'English', 'Spanish'],
    languageFr: ['Français', 'Anglais', 'Espagnol'],
    sectorFocus: ['Food & Agriculture'],
    sectorFocusFr: ['Agroalimentaire'],
    countryFocus: ['France', 'Spain'],
    countryFocusFr: ['France', 'Espagne'],
    functionalExpertise: ['Project Management'],
    functionalExpertiseFr: ['Gestion de Projets'],
    image: TEAM_IMAGES.candiceMangin,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/candice-mangin-moret-industries-06a244126',
    team: 'portfolio-management',
    position: 'associate',
    office: 'paris'
  },
  {
    name: 'Fran\u00e7ois Paque',
    title: 'Information Technology Associate',
    title2: 'Moret Industries Group',
    titles: [
      'Information Technology Associate, Moret Industries Group'
    ],
    titleFr: 'Collaborateur en technologies de l\'information',
    title2Fr: 'Moret Industries Group',
    titlesFr: [
      'Collaborateur en technologies de l\'information, Moret Industries Group'
    ],
    bio: 'Francois is Systems Administrator at Moret Industries, where he has been working in the Technology team for the past 10 years. Previously, Francois worked at Andalys where he provided IT services to industrial companies. Francois is responsible for the design, administration and protection of network architectures, including LAN and VLAN environments, inter-site connectivity and advanced firewall management. Fran\u00e7ois manages security appliances across multiple technologies, including Cisco, Fortinet, Stormshield and OPNsense firewalls, ensuring robust perimeter security and effective network segmentation.',
    bioFr: 'François est administrateur systèmes chez Moret Industries, où il travaille au sein de l\'équipe technologique depuis 10 ans. Auparavant, il travaillait chez Andalys où il fournissait des services informatiques aux entreprises industrielles. François est responsable de la conception, de l\'administration et de la protection des architectures réseau, incluant les environnements LAN et VLAN, la connectivité inter-sites et la gestion avancée des pare-feu. Il gère les dispositifs de sécurité sur de multiples technologies, dont Cisco, Fortinet, Stormshield et OPNsense.',
    education: 'Francois holds a Bachelor\'s in IT Management & Administration',
    educationFr: 'Licence en gestion et administration informatique.',
    language: ['French', 'English'],
    languageFr: ['Français', 'Anglais'],
    sectorFocus: ['Aerospace & Defence'],
    sectorFocusFr: ['Aérospatiale et défense'],
    countryFocus: ['France', 'Benelux', 'Switzerland'],
    countryFocusFr: ['France', 'Benelux', 'Suisse'],
    functionalExpertise: ['Technology'],
    functionalExpertiseFr: ['Technologie'],
    image: TEAM_IMAGES.francoisPaque,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/fran%C3%A7ois-paque-02124a138',
    team: 'value-creation',
    position: 'associate',
    office: 'paris'
  },
  {
    name: 'Malory Mertz',
    title: 'Information Technology Associate',
    title2: 'Moret Industries Group',
    titles: [
      'Information Technology Associate, Moret Industries Group'
    ],
    titleFr: 'Collaborateur en technologies de l\'information',
    title2Fr: 'Moret Industries Group',
    titlesFr: [
      'Collaborateur en technologies de l\'information, Moret Industries Group'
    ],
    bio: 'Malory Mertz is an IT Specialist within the Value Creation Group. Malory joined Moret Industries in 2018. He supports all entities on IT topics across a complex industrial and network environment composed of multiple sites, companies, and domains. Malory also contributes to endpoint security operations and management of mobile environments. Alongside his support to portfolio companies, Malory participates in IT service management (ITSM) and IT asset lifecycle management. He also collaborates in the operational follow-up of IT service providers and contracts, helping coordinate vendors and maintain service continuity across the portfolio.',
    bioFr: 'Malory Mertz est spécialiste informatique au sein du groupe Création de Valeur. Il a rejoint Moret Industries en 2018. Il accompagne toutes les entités sur les sujets informatiques dans un environnement industriel et réseau complexe composé de multiples sites, entreprises et domaines. Malory contribue également aux opérations de sécurité des terminaux et à la gestion des environnements mobiles. Il participe à la gestion des services informatiques (ITSM) et à la gestion du cycle de vie des actifs informatiques. Il collabore aussi au suivi opérationnel des prestataires et contrats informatiques.',
    education: 'Malory holds a BTS in IT Management \u2013 Networks & Systems Administration',
    educationFr: 'BTS en gestion informatique – Réseaux et administration des systèmes.',
    language: ['French', 'English'],
    languageFr: ['Français', 'Anglais'],
    sectorFocus: ['Technology'],
    sectorFocusFr: ['Technologie'],
    countryFocus: ['Pan European'],
    countryFocusFr: ['Pan-européen'],
    functionalExpertise: ['Information Technology & Systems'],
    functionalExpertiseFr: ['Technologies de l\'Information & Systèmes'],
    image: TEAM_IMAGES.maloryMertz,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/malory-mertz-a938a1172',
    team: 'value-creation',
    position: 'associate',
    office: 'paris'
  }
];

// Portfolio Executives
export const portfolioExecutives = [
  {
    name: 'Thomas Holst',
    title: 'Vettertec - Chief Executive Officer',
    experience: [],
    tags: ['CEO', 'Portfolio'],
    image: TEAM_IMAGES.missingDetails,
    linkedin: null,
    team: 'portfolio-executives',
    position: 'director',
    office: 'germany'
  },
  {
    name: 'Arnaud Mayer',
    title: 'Fapmo - Chief Executive Officer',
    experience: [],
    tags: ['CEO', 'Portfolio'],
    image: TEAM_IMAGES.missingDetails,
    linkedin: null,
    team: 'portfolio-executives',
    position: 'director',
    office: 'france'
  },
  {
    name: 'Francois-Xavier Desjars',
    title: 'TCEM - Chief Executive Officer',
    experience: [],
    tags: ['CEO', 'Portfolio'],
    image: TEAM_IMAGES.missingDetails,
    linkedin: null,
    team: 'portfolio-executives',
    position: 'director',
    office: 'france'
  },
  {
    name: 'Gr\u00e9gory Freva',
    title: 'Maguin Promill - Acting Chief Executive Officer',
    experience: [],
    tags: ['CEO', 'Portfolio'],
    image: TEAM_IMAGES.gregoryFreva,
    linkedin: 'https://www.linkedin.com/in/gregory-freva',
    team: 'portfolio-executives',
    position: 'director',
    office: 'france'
  }
];

// Senior Advisory Group
export const seniorAdvisory = [
  {
    name: 'Philippe Carli',
    title: 'Senior Advisor, Ocean Peak Group',
    title2: 'Chairman of the Board, Moret Industries Group',
    titles: [
      'Senior Advisor, Ocean Peak Group',
      'Chairman of the Board, Moret Industries Group'
    ],
    titleFr: 'Conseiller senior, Ocean Peak Group',
    title2Fr: 'Président du conseil d\'administration, Moret Industries Group',
    titlesFr: [
      'Conseiller senior, Ocean Peak Group',
      'Président du conseil d\'administration, Moret Industries Group'
    ],
    bio: 'Philippe started his career in 1985 in the Defence division of Aerospatiale (Airbus) before joining Siemens Group in Germany. After a stint at Hewlett Packard, Philippe rejoined Siemens in 1991, where he held various management positions in France and Germany. In 2002, Philippe became CEO of Siemens France, which he turned around and developed, and in 2007 he became Vice President of the Energy Sector for southwest Europe. In 2010, Philippe joined the family-owned company AMAURY (a leader in sport events and media) as CEO to redefine the strategy, set up professional governance and turn around the media activity. In 2017 Philippe joined Credit Mutuel as member of the Executive Committee and CEO of its media group EBRA (1st regional Newspaper group in France) where he executed a deep restructuring and digital transformation while diversifying the revenues by selected M&A.',
    bioFr: 'Philippe a débuté sa carrière en 1985 dans la division Défense d\'Aerospatiale (Airbus) avant de rejoindre Siemens Group en Allemagne. Après un passage chez Hewlett Packard, Philippe a réintégré Siemens en 1991, où il a occupé divers postes de direction en France et en Allemagne. En 2002, Philippe est devenu directeur général de Siemens France, qu\'il a redressé et développé, et en 2007, il est devenu vice-président du secteur Énergie pour le sud-ouest de l\'Europe. En 2010, Philippe a rejoint l\'entreprise familiale AMAURY (leader dans les événements sportifs et les médias) en tant que directeur général pour redéfinir la stratégie, mettre en place une gouvernance professionnelle et redresser l\'activité médias. En 2017, Philippe a rejoint le Crédit Mutuel en tant que membre du comité exécutif et directeur général de son groupe de presse EBRA (1er groupe de presse régionale en France) où il a mené une restructuration profonde et une transformation numérique tout en diversifiant les revenus par des opérations de fusions-acquisitions ciblées.',
    education: 'Philippe is a graduate of CentraleSupelec Paris, with a MSC in Solid Physics of the University of Marseille and Certificate of the Fuqua school of business in Durham (NC).',
    educationFr: 'Diplômé de CentraleSupelec Paris, avec un MSC en physique des solides de l\'Université de Marseille et un certificat de la Fuqua School of Business de Durham (Caroline du Nord).',
    language: ['French', 'English', 'German'],
    languageFr: ['Français', 'Anglais', 'Allemand'],
    sectorFocus: ['Energy & Utilities', 'Healthcare'],
    sectorFocusFr: ['Énergie et services publics', 'Santé'],
    countryFocus: ['France', 'Germany', 'Benelux'],
    countryFocusFr: ['France', 'Allemagne', 'Benelux'],
    functionalExpertise: ['Strategy', 'Management', 'Governance'],
    functionalExpertiseFr: ['Stratégie', 'Management', 'Gouvernance'],
    image: TEAM_IMAGES.philippeCarli,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/philippe-carli-3931344',
    team: 'senior-advisory',
    position: 'senior-adviser',
    office: 'paris'
  },
  {
    name: "Kathleen Wantz-O'Rourke",
    title: 'Senior Advisor, Ocean Peak Group',
    title2: 'Board member, Moret Industries Group',
    titles: [
      'Senior Advisor, Ocean Peak Group',
      'Board member, Moret Industries Group'
    ],
    titleFr: 'Conseillère senior, Ocean Peak Group',
    title2Fr: 'Membre du conseil d\'administration, Moret Industries Group',
    titlesFr: [
      'Conseillère senior, Ocean Peak Group',
      'Membre du conseil d\'administration, Moret Industries Group'
    ],
    bio: 'Kathleen is a Senior Advisor at Ocean Peak and a Board Member at Moret Industries. Kathleen has served as a C-suite executive in major international corporations with multi-billion revenues. In addition to executive positions, Kathleen has held non-executive roles in both private and publicly listed organizations, including chairing audit committees. Kathleen possesses substantial industrial expertise in France and internationally, spanning both public and private sectors. Her experience covers industrial manufacturing, energy, water and waste utilities, and mobility. Kathleen is particularly skilled in governance, strategic planning, finance, and leading diverse, multinational teams. Kathleen also presides over the Turgot Literary Prize and the Association of Students and Alumni of the Institute of High Finance in France.',
    bioFr: 'Kathleen est conseillère senior chez Ocean Peak et membre du conseil d\'administration de Moret Industries. Elle a exercé des fonctions de direction générale dans de grandes entreprises internationales générant des chiffres d\'affaires de plusieurs milliards. En plus de ses postes exécutifs, Kathleen a occupé des fonctions non exécutives dans des organisations privées et cotées, y compris la présidence de comités d\'audit. Elle possède une expertise industrielle substantielle en France et à l\'international, couvrant les secteurs public et privé. Son expérience englobe la fabrication industrielle, l\'énergie, l\'eau et les déchets, les services publics et la mobilité. Elle est particulièrement compétente en gouvernance, planification stratégique, finance, et direction d\'équipes multinationales diversifiées. Kathleen préside également le Prix littéraire Turgot et l\'Association des Étudiants et Anciens de l\'Institut de la Haute Finance en France.',
    education: 'Kathleen holds a Master\u2019s II-degree, Expert in High Finance, from the Institute of High Finance in France and an MSc in business from Paris Dauphine University. She is also a graduate of Duke University\u2019s Advanced Management program and the Nuremberg Chamber of Industry & Commerce.',
    educationFr: 'Master II, Experte en Haute Finance, de l\'Institut de la Haute Finance en France et MSc en commerce de l\'Université Paris Dauphine. Diplômée du programme Advanced Management de Duke University et de la Chambre de l\'Industrie et du Commerce de Nuremberg.',
    language: ['English', 'French', 'German'],
    languageFr: ['Anglais', 'Français', 'Allemand'],
    sectorFocus: ['Energy & Utilities', 'Automotive'],
    sectorFocusFr: ['Énergie et services publics', 'Automobile'],
    countryFocus: ['France', 'Germany', 'Benelux'],
    countryFocusFr: ['France', 'Allemagne', 'Benelux'],
    functionalExpertise: ['Strategy', 'Finance', 'Management'],
    functionalExpertiseFr: ['Stratégie', 'Finance', 'Management'],
    image: TEAM_IMAGES.kathleenWantz,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/kathleen-wantz-o-rourke',
    team: 'senior-advisory',
    position: 'senior-adviser',
    office: 'paris'
  },
  {
    name: 'Marwan Lahoud',
    title: 'Senior Advisor, Ocean Peak Group',
    titles: [
      'Senior Advisor, Ocean Peak Group'
    ],
    titleFr: 'Conseiller senior, Ocean Peak Group',
    titlesFr: [
      'Conseiller senior, Ocean Peak Group'
    ],
    bio: 'Marwan began his career at the French Defence procurement agency DGA in 1989. In 1995, he was appointed Special Advisor to the French Ministry of Defence. In May 1998, he joined Aerospatiale as Vice President Development. In June 1999, he was appointed Senior Vice President Strategy and Planning for Aerospatiale Matra, where he also served as Senior Vice President Military Affairs. After the foundation of EADS in 2000, M. Lahoud was appointed Senior Vice President Mergers & Acquisitions. During his tenure, he oversaw the creation of Airbus, MBDA and Astrium. Marwan then became CEO of MBDA from 2003 to 2007. He then rejoined Airbus in 2007 as Chief Strategy and Marketing Officer, until February 2017. Marwan joined Tikehau Capital in 2018, and became Executive Chairman of Tikehau Ace Capital (previously ACE Management). In 2023 he served as Deputy CEO, before joining Messier & Associes as partners.',
    bioFr: 'Marwan a débuté sa carrière à la Direction Générale de l\'Armement (DGA) en 1989. En 1995, il a été nommé conseiller spécial auprès du ministère français de la Défense. En mai 1998, il a rejoint Aerospatiale en tant que vice-président Développement. En juin 1999, il a été nommé vice-président senior Stratégie et Planification d\'Aerospatiale Matra, où il a également exercé les fonctions de vice-président senior Affaires militaires. Après la création d\'EADS en 2000, M. Lahoud a été nommé vice-président senior Fusions et Acquisitions. Durant son mandat, il a supervisé la création d\'Airbus, MBDA et Astrium. Marwan est ensuite devenu directeur général de MBDA de 2003 à 2007. Il a ensuite rejoint Airbus en 2007 en tant que directeur de la stratégie et du marketing, jusqu\'en février 2017. Marwan a rejoint Tikehau Capital en 2018 et est devenu président exécutif de Tikehau Ace Capital (anciennement ACE Management). En 2023, il a exercé les fonctions de directeur général adjoint, avant de rejoindre Messier & Associes en tant qu\'associé.',
    education: 'Marwan is a graduate of Ecole Polytechnique and of \u00c9cole Nationale Sup\u00e9rieure de l\'A\u00e9ronautique et de l\'Espace (SupAero).',
    educationFr: 'Diplômé de l\'École Polytechnique et de l\'École Nationale Supérieure de l\'Aéronautique et de l\'Espace (SupAero).',
    language: ['French', 'English', 'Arabic', 'German', 'Chinese', 'Italian'],
    languageFr: ['Français', 'Anglais', 'Arabe', 'Allemand', 'Chinois', 'Italien'],
    sectorFocus: ['Aerospace & Defence'],
    sectorFocusFr: ['Aérospatiale et défense'],
    countryFocus: ['France', 'Germany', 'United Kingdom', 'Spain', 'Italy'],
    countryFocusFr: ['France', 'Allemagne', 'Royaume-Uni', 'Espagne', 'Italie'],
    functionalExpertise: ['Strategy', 'Management', 'Finance'],
    functionalExpertiseFr: ['Stratégie', 'Management', 'Finance'],
    image: TEAM_IMAGES.marwanLahoud,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/marwan-lahoud-81894213b',
    team: 'senior-advisory',
    position: 'senior-adviser',
    office: 'paris'
  },
  {
    name: 'Yannick Bezard',
    title: 'Senior Advisor, Ocean Peak Group',
    title2: 'Board member, Moret Industries Group',
    titles: [
      'Senior Advisor, Ocean Peak Group',
      'Board member, Moret Industries Group'
    ],
    titleFr: 'Conseiller senior, Ocean Peak Group',
    title2Fr: 'Membre du conseil d\'administration, Moret Industries Group',
    titlesFr: [
      'Conseiller senior, Ocean Peak Group',
      'Membre du conseil d\'administration, Moret Industries Group'
    ],
    bio: 'Yannick is a Senior Advisor at Ocean Peak, and a Board Member at Moret Industries. Previously, Yannick spent most of his career at PSA Group, in various roles - Purchasing, Manufacturing Quality, R&D and Program Management in Europe and South America \u2013 until he became Executive Vice-President in charge of Global Purchasing and Eurasia region during 9 years.',
    bioFr: 'Yannick est conseiller senior chez Ocean Peak et membre du conseil d\'administration de Moret Industries. Auparavant, Yannick a passé l\'essentiel de sa carrière chez PSA Group, dans divers rôles — achats, qualité de fabrication, R&D et gestion de programmes en Europe et en Amérique du Sud — jusqu\'à devenir vice-président exécutif en charge des achats mondiaux et de la région Eurasie pendant 9 ans.',
    education: 'Yannick is a graduate of Centrale Paris',
    educationFr: 'Diplômé de Centrale Paris.',
    language: ['French', 'English', 'Spanish'],
    languageFr: ['Français', 'Anglais', 'Espagnol'],
    sectorFocus: ['Automotive'],
    sectorFocusFr: ['Automobile'],
    countryFocus: ['France', 'United Kingdom', 'Germany'],
    countryFocusFr: ['France', 'Royaume-Uni', 'Allemagne'],
    functionalExpertise: ['Purchasing', 'Strategy', 'Management'],
    functionalExpertiseFr: ['Achats', 'Stratégie', 'Management'],
    image: TEAM_IMAGES.yannickBezard,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/yannick-bezard-314367a',
    team: 'senior-advisory',
    position: 'senior-adviser',
    office: 'paris'
  },
  {
    name: 'Bernard Landes',
    title: 'Senior Advisor, Ocean Peak Group',
    title2: 'Board member, Moret Industries Group',
    titles: [
      'Senior Advisor, Ocean Peak Group',
      'Board member, Moret Industries Group'
    ],
    titleFr: 'Conseiller senior, Ocean Peak Group',
    title2Fr: 'Membre du conseil d\'administration, Moret Industries Group',
    titlesFr: [
      'Conseiller senior, Ocean Peak Group',
      'Membre du conseil d\'administration, Moret Industries Group'
    ],
    bio: 'Bernard is a Senior Advisor at Ocean Peak and a Board member of Moret Industries. Previously, Bernard held various management and finance positions at global pharmaceutical and technology companies. Most recently, Bernard turned around and developed two medical imaging midmarket companies, including launching a new breast cancer imaging molecule in the US, before selling the first company to Curium Pharmaceuticals and the second one to GE Healthcare.',
    bioFr: 'Bernard est conseiller senior chez Ocean Peak et membre du conseil d\'administration de Moret Industries. Auparavant, il a occupé divers postes de direction et de finance dans des entreprises pharmaceutiques et technologiques mondiales. Plus récemment, Bernard a redressé et développé deux entreprises de taille intermédiaire dans l\'imagerie médicale, y compris le lancement d\'une nouvelle molécule d\'imagerie du cancer du sein aux États-Unis, avant de vendre la première à Curium Pharmaceuticals et la seconde à GE Healthcare.',
    education: 'Bernard is a graduate of INSEAD and Neoma business schools.',
    educationFr: 'Diplômé de l\'INSEAD et de Neoma Business School.',
    language: ['English', 'French', 'German'],
    languageFr: ['Anglais', 'Français', 'Allemand'],
    sectorFocus: ['Pharmaceuticals', 'MedTech'],
    sectorFocusFr: ['Pharmaceutique', 'Technologies médicales (MedTech)'],
    countryFocus: ['France', 'Germany'],
    countryFocusFr: ['France', 'Allemagne'],
    functionalExpertise: ['Strategy', 'Finance', 'Management'],
    functionalExpertiseFr: ['Stratégie', 'Finance', 'Management'],
    image: TEAM_IMAGES.bernardLandes,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/bernardlandes',
    team: 'senior-advisory',
    position: 'senior-adviser',
    office: 'paris'
  },
  {
    name: 'Isabelle Driver',
    title: 'Senior Advisor, Ocean Peak Group',
    title2: 'Board member, Moret Industries Group',
    titles: [
      'Senior Advisor, Ocean Peak Group',
      'Board member, Moret Industries Group'
    ],
    titleFr: 'Conseillère senior, Ocean Peak Group',
    title2Fr: 'Membre du conseil d\'administration, Moret Industries Group',
    titlesFr: [
      'Conseillère senior, Ocean Peak Group',
      'Membre du conseil d\'administration, Moret Industries Group'
    ],
    bio: 'Isabelle is an experienced international leader in Sales, Supply Chain & Finance, with 25 years of track records both in operational & functional environments. Her breadth of experience spanning Airbus Helicopters and Michelin reflects a profile shaped by operational complexity, strategic leadership, and enterprise-level accountability. She currently leads Procurement & Logistics for Airbus Helicopters across 1500 suppliers, a \u20ac2.2Bn purchasing volume with a high impact on transformation and operational excellence.',
    bioFr: 'Isabelle est une dirigeante internationale expérimentée dans les domaines des ventes, de la chaîne d\'approvisionnement et de la finance, avec 25 ans d\'expérience dans des environnements opérationnels et fonctionnels. Son parcours chez Airbus Helicopters et Michelin reflète un profil façonné par la complexité opérationnelle, le leadership stratégique et la responsabilité au niveau de l\'entreprise. Elle dirige actuellement les achats et la logistique pour Airbus Helicopters auprès de 1 500 fournisseurs, représentant un volume d\'achats de 2,2 Md€ avec un impact significatif sur la transformation et l\'excellence opérationnelle.',
    education: 'ESPCI, Paris Tech: Physics, chemicals & biology Engineering degree / Master of Science. IFP School: Master of Science in Economics & Management. HEC Executive Education (Business Pilotage Performance). Stanford University Graduate (Strategies and Leadership in Supply Chains).',
    educationFr: 'ESPCI, Paris Tech : diplôme d\'ingénieur en physique, chimie et biologie / Master of Science. IFP School : Master of Science en économie et management. HEC Executive Education (Business Pilotage Performance). Stanford University Graduate (Stratégies et leadership dans les chaînes d\'approvisionnement).',
    language: ['English', 'French'],
    languageFr: ['Anglais', 'Français'],
    sectorFocus: ['Aerospace & Defence', 'Automotive'],
    sectorFocusFr: ['Aérospatiale et défense', 'Automobile'],
    countryFocus: ['France', 'Germany', 'Spain'],
    countryFocusFr: ['France', 'Allemagne', 'Espagne'],
    functionalExpertise: ['Supply Chain', 'Operational Excellence', 'Sales'],
    functionalExpertiseFr: ['Supply Chain', 'Excellence Opérationnelle', 'Commercial'],
    image: TEAM_IMAGES.isabelleDriver,
    imageScale: 1.15,
    imagePosition: 'center 0%',
    linkedin: 'https://www.linkedin.com/in/isabelledriver',
    team: 'senior-advisory',
    position: 'senior-adviser',
    office: 'paris'
  },
  {
    name: 'J\u00e9r\u00f4me Duprez',
    title: 'Senior Advisor, Ocean Peak Group',
    title2: 'Board Member, Moret Industries Group',
    titles: [
      'Senior Advisor, Ocean Peak Group',
      'Board Member, Moret Industries Group'
    ],
    titleFr: 'Conseiller senior, Ocean Peak Group',
    title2Fr: 'Membre du conseil d\'administration, Moret Industries Group',
    titlesFr: [
      'Conseiller senior',
      'Membre du conseil d\'administration, Moret Industries Group'
    ],
    bio: 'J\u00e9r\u00f4me was President of Moret Industries between 2000 and 2017 and contributed to the growth and internationalization of the group. Jerome has deep knowledge and networks in the core markets of Moret Industries (Food & Agriculture, and Sugar especially, and Pumps sectors).',
    bioFr: 'Jérôme a été président de Moret Industries entre 2000 et 2017 et a contribué à la croissance et à l\'internationalisation du groupe. Il possède une connaissance approfondie et un réseau étendu dans les marchés principaux de Moret Industries (agroalimentaire, et notamment le sucre, et les secteurs des pompes).',
    education: 'J\u00e9r\u00f4me is a graduate of ESME (engineering) and holds an MBA from IAE Paris',
    educationFr: 'Diplômé de l\'ESME (ingénierie) et titulaire d\'un MBA de HEC Paris.',
    language: ['French', 'English'],
    languageFr: ['Français', 'Anglais'],
    sectorFocus: ['Food & Agriculture', 'Energy & Utilities'],
    sectorFocusFr: ['Agroalimentaire', 'Énergie et services publics'],
    countryFocus: ['France', 'Germany', 'Benelux'],
    countryFocusFr: ['France', 'Allemagne', 'Benelux'],
    functionalExpertise: ['Strategy', 'Management'],
    functionalExpertiseFr: ['Stratégie', 'Management'],
    image: TEAM_IMAGES.jeromeDuprez,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/j%C3%A9r%C3%B4me-duprez-7a1344104',
    team: 'senior-advisory',
    position: 'senior-adviser',
    office: 'paris'
  },
  {
    name: 'Christophe Carli',
    title: 'Senior Advisor, Ocean Peak Group',
    title2: 'Board member, Moret Industries Group',
    titles: [
      'Senior Advisor, Ocean Peak Group',
      'Board member, Moret Industries Group'
    ],
    titleFr: 'Conseiller senior, Ocean Peak Group',
    title2Fr: 'Membre du conseil d\'administration, Moret Industries Group',
    titlesFr: [
      'Conseiller senior, Ocean Peak Group',
      'Membre du conseil d\'administration, Moret Industries Group'
    ],
    bio: 'Christophe is a Board Member of Moret Industries. He previously held senior finance roles at Honeywell, a Fortune 100 industrial technology group, where he was actively involved in the spin-off of Garrett Motion, now listed on Nasdaq.',
    bioFr: 'Christophe est membre du conseil d\'administration de Moret Industries. Il a précédemment occupé des postes de direction financière chez Honeywell, un groupe technologique industriel du Fortune 100, où il a participé activement à la scission de Garrett Motion, désormais coté au Nasdaq.',
    education: 'Christophe is a graduate of ESCP Business school.',
    educationFr: 'Diplômé de l\'ESCP Business School.',
    language: ['English', 'French'],
    languageFr: ['Anglais', 'Français'],
    sectorFocus: ['Automotive'],
    sectorFocusFr: ['Automobile'],
    countryFocus: ['France', 'Switzerland'],
    countryFocusFr: ['France', 'Suisse'],
    functionalExpertise: ['Finance'],
    functionalExpertiseFr: ['Finance'],
    image: TEAM_IMAGES.christopheCarli,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/christophe-carli-128a23',
    team: 'senior-advisory',
    position: 'senior-adviser',
    office: 'paris'
  },
  {
    name: 'Loïc Bournon',
    title: 'Senior Advisor, Ocean Peak Group',
    titleFr: 'Senior Advisor, Ocean Peak Group',
    image: TEAM_IMAGES.loicBournon,
    imageScale: 1.15,
    imagePosition: 'center 10%',
    linkedin: 'https://www.linkedin.com/in/loic-bournon',
    bio: 'Loïc is a growth-driven leader with over 30 years of expertise in Digital Security and Transformation. Named by Forbes as one of the "Top 15 Most Influential IT Personalities in France" (2021), he has a proven track record of leading massive digital shifts within high-stakes international environments. Loïc has built his career at the intersection of high-level government administration and heavy industry. Following a PhD in cryptography and a distinguished tenure at the French National Security Agency, he held executive leadership roles within the Safran Group. Notably, he spearheaded the creation of Morpho\'s IT department before serving as SAFRAN Group CIO, overseeing global information systems during a period of significant international growth. Currently a Senior Advisor at Ocean Peak and previously Operating Partner at Tikehau Ace Capital, Loïc is also Senior Advisor at Sopra Steria Aeroline, and an IHEDN alumnus. Loïc advises organizations on cyber governance and M&A transformation, with a particular focus on the aerospace and defense sectors.',
    bioFr: 'Loïc est un dirigeant orienté croissance, fort de plus de 30 ans d\'expertise en sécurité numérique et transformation digitale. Désigné par Forbes comme l\'une des « 15 personnalités IT les plus influentes en France » (2021), il possède une expérience avérée dans la conduite de transformations numériques majeures au sein d\'environnements internationaux à forts enjeux. Loïc a construit sa carrière à l\'intersection de la haute administration publique et de l\'industrie lourde. Après un doctorat en cryptographie et un parcours remarqué au sein de l\'Agence nationale de la sécurité des systèmes d\'information (ANSSI), il a occupé des postes de direction au sein du groupe Safran. Il a notamment piloté la création de la direction informatique de Morpho avant de devenir Directeur des Systèmes d\'Information du groupe SAFRAN, supervisant les systèmes d\'information à l\'échelle mondiale durant une période de forte croissance internationale. Actuellement Senior Advisor chez Ocean Peak et précédemment Operating Partner chez Tikehau Ace Capital, Loïc est également Senior Advisor auprès de Sopra Steria Aeroline et ancien auditeur de l\'IHEDN. Il conseille les organisations en matière de gouvernance cyber et de transformation dans le cadre d\'opérations de fusions-acquisitions, avec un focus particulier sur les secteurs de l\'aérospatiale et de la défense.',
    education: 'PhD in Cryptography and Applied Mathematics. Alumnus of IHEDN (56th National Session).',
    educationFr: 'Doctorat en cryptographie et mathématiques appliquées. Auditeur de l\'IHEDN (56ème session nationale).',
    language: ['English', 'French'],
    languageFr: ['Anglais', 'Français'],
    sectorFocus: ['Aerospace & Defense'],
    sectorFocusFr: ['Aérospatiale & Défense'],
    functionalExpertise: ['IT Strategy', 'Digital Transformation', 'Cybersecurity'],
    functionalExpertiseFr: ['Stratégie IT', 'Transformation digitale', 'Cybersécurité'],
    countryFocus: ['Pan-European'],
    countryFocusFr: ['Pan-européen'],
    team: 'senior-advisory',
    position: 'senior-adviser',
    office: 'paris'
  },
  {
    name: "Mayline BENAETS",
    title: 'Marketing & Communications Apprentice',
    title2: 'Moret Industries Group',
    titles: [
      'Marketing & Communications Apprentice, Moret Industries Group'
    ],
    titleFr: 'Alternante Marketing & Communication',
    title2Fr: 'Moret Industries Group',
    titlesFr: [
      'Directrice financière, Moret Industries Group'
    ],
    bio: "Mayline, she works on both internal and external communication projects, with a focus on strengthening the visibility of the group and its subsidiaries. Dynamic, curious and creative, she enjoys designing communication projects that inspire and bring people together. To her, communication is more than just a tool. It's a way to share ideas, convey emotions and build meaningful connections between people.",
    bioFr: 'Mayline, intervient sur des missions de communication interne et externe avec pour objectif de renforcer la visibilité du groupe et de ses filiales. Dynamique, curieuse et créative, elle aime concevoir des projets de communication qui donnent envie et qui rassemblent. Pour elle, la communication est bien plus qu\'un outil : c\'est un moyen de partager des idées, de transmettre des émotions et de créer du lien entre les personnes.',
    education: 'Mayline is currently pursuing a Master\'s 1 in 360° Communication at ECS Reims – MediaSchool, where she is developing a comprehensive understanding of global communication strategy.',
    educationFr: 'Actuellement en Mastère 1 à l\'ECS Reims – MediaSchool, Mayline se spécialise en communication 360 pour maîtriser tous les aspects d\'une stratégie de communication globale.',
    language: ['French'],
    languageFr: ['Français'],
    sectorFocus: ['Marketing & Communications'],
    sectorFocusFr: ['Marketing & Communications'],
    functionalExpertise: ['Communication', 'Social Network', 'Technology'],
    functionalExpertiseFr: ['Communication', 'Réseau Social', 'Technologie'],
    countryFocus: ['France'],
    countryFocusFr: ['France'],
    image: TEAM_IMAGES.maylineBenaets,
    imageScale: 1.15,
    imagePosition: 'center 0%',
    linkedin: 'https://www.linkedin.com/in/mayline-benaets-990710229/',
    team: 'portfolio-management',
    position: 'associate',
    office: 'paris'
  }
];

// Legacy exports for backward compatibility
export const portfolioOperations = valueCreationGroup;
export const executiveGroup = portfolioExecutives;
